import { InfoCircleHollowSVG, TooltipDialog, Widget } from "@newsela/angelou";
import PropTypes from "prop-types";

import withTrackEvent from "@/eventStream/withTrackEvent";
import { widgetCss, toolTipCss } from "./ChallengesWidget.style";

const propTypes = {
  children: PropTypes.element,
  TooltipObj: PropTypes.any,
  title: PropTypes.string,
};

const ChallengesWidget = ({ children, TooltipObj, title }) => {
  const eventProperties = {
    objectType: "User",
    actionName: "Interact",
    event_type: "click",
    streamProperties: {
      content_type: "Tooltip",
      component_type: "ChallengesWidget",
      description: `Open Tooltip ${TooltipObj?.title}`,
    },
  };
  const TooltipDialogWithTrackEvent = withTrackEvent(TooltipDialog);
  return (
    <Widget title={title || "Tokens earned"} __cssFor={{ root: widgetCss }}>
      {TooltipObj && (
        <TooltipDialogWithTrackEvent
          body={TooltipObj?.text}
          buttonContents={<InfoCircleHollowSVG className="infoIcon" />}
          buttonProps={{
            flavor: "TERTIARY",
          }}
          __cssFor={{ Button: { root: toolTipCss } }}
          header={TooltipObj?.title}
          {...eventProperties}
        />
      )}
      {children}
    </Widget>
  );
};

ChallengesWidget.propTypes = propTypes;

export default ChallengesWidget;
